<template>
    <div>
        <div class="dosion-upload-list" v-if="image&& fileList!=null" v-for="(item,index) in fileList">
            <template v-if="item!=null">
                <img :src="item">
                <div class="dosion-upload-list-cover">
                    <Icon type="ios-trash-outline" @click="removeImage(index)"></Icon>
                     <Icon type="md-expand"  @click="viewImage(item)"/>
                </div>
            </template>
        </div>
        <Upload :type="image?'drag':type"
                :before-upload="handleBeforeUpload"
                :action="uploadPath()"
                :max-size="maxSize"
                :data="uploadData()"
                :headers="uploadHeaders()"
                :multiple="multiple"
                :on-success="uploadSuccess"
                :show-upload-list="false"
                :style="{display: image?'inline-block':'',width:image?'58px':''}">
            <Button v-if="!image&&type=='select'&&this.ocr!='taxTem1'&&this.ocr!='taxTem2'" icon="ios-cloud-upload-outline">点击上传</Button>
            <Button v-else-if="!image&&this.ocr=='taxTem1'" icon="ios-cloud-upload-outline" >导入增值税</Button>
            <Button v-else-if="!image&&this.ocr=='taxTem2'" icon="ios-cloud-upload-outline" >导入个人税</Button>
            <div v-if="!image&&type=='drag'" style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>将文件拖拽到此，或点击上传</p>
                <p>允许上传图片格式： png, jpg, jpeg, PNG, JPG, JPEG</p>
            </div>
            <div v-if="image" style="width: 58px;height:58px;line-height: 58px;">
                <Icon type="ios-camera" size="20"></Icon>
            </div>
        </Upload>
        <ul class="ivu-upload-list" v-if="!image && showFile">
            <li class="ivu-upload-list-file ivu-upload-list-file-finish" v-for="(item,index) in fileList" :key="index">
                <span>
                    <i v-if="image" class="ivu-icon ivu-icon-ios-image"></i>
                    {{item.original}}
                </span>
                <Button  icon="ios-cloud-upload-outline" @click="downloadPdf(item.url)">下载</Button>
                <template v-if="/\.pdf$/.test(item.original)">
                    <i class="ivu-icon el-icon-view ivu-upload-list-remove" @click.stop="viewPdf(item.url)" style=""></i>
                    <i class="ivu-icon el-icon-download ivu-upload-list-remove" @click.stop="downloadPdf(item.url)" style=""></i>
                </template>
                <i class="ivu-icon ivu-icon-ios-close ivu-upload-list-remove" @click.stop="removeImage(index)" style=""></i>
            </li>
        </ul>
        <Modal
            v-model="pdfShow"
            width="80%"
            @on-ok="pdfShow = false">
            <vue-office-pdf
                :src="pdfUrl"
            />
        </Modal>
      <Modal
          class="imgModel"
          v-model="imgShow"
          title="查看"
           footer-hide
          @on-ok="imgShow = false"
          @on-cancel="imgShow = false">
        <div>
          <img :src="imgUrl" style="width: 100%"/>
        </div>
      </Modal>
    </div>
</template>

<script>
    import appUtils from '@/utils/appUtils';
    import Setting from '@/setting';
    import secretUtils from '@/utils/secretUtils';
    import dataUtils from '@/utils/dataUtils';
    import VueOfficePdf from '@vue-office/pdf'

    export default {
        name: 'dosion-upload',
        components:{
            VueOfficePdf
        },
        props: {
            value: {
                type: String
            },
            multiple: {
                type: Boolean
            },
            showFile: {
                type: Boolean
            },
            image: {
                type: Boolean
            },
            type: {
                type: String,
                default: 'select'
            },
            ocr: {
                type: String,
                default: ''
            },
            limit: {
                type: Number
            },
          maxSize: {
            type: Number,
            },
          contractSizeFlag: {
            type: Boolean,
            default: false
            }
        },
        data () {
            return {
                fileList: [],
                Setting,
                pdfShow:false,
                pdfUrl:'',
                imgShow:false,
                imgUrl:'',
                typeArr: ["image/png", "image/jpg", "image/jpeg","application/pdf","application/PDF"],//上传类型限制
                imgTypeArr: ["image/png", "image/jpg", "image/jpeg"],//上传类型限制
            };
        },
        watch: {
            value () {
              console.log(this.maxSize)
                if (this.value != null && this.value != '') {
                    if (!this.image){
                        let parse = JSON.parse(this.value);
                        if (this.multiple){
                            this.fileList = parse
                        } else{
                            this.fileList = [parse]
                        }

                    } else{
                        let parse = JSON.parse(this.value);
                        let img = dataUtils.getImg(parse.bucketName, parse.fileName);
                        this.fileList = [img]
                    }
                } else {
                    this.fileList = []
                }
            }
        },
        methods: {
            uploadData () {
                let data = {
                    ocr: this.ocr
                }
                return data
            },
            //上传路径
            uploadPath () {
                return Setting.apiBaseURL + '/system/file/upload'
            },
            //上传请求头
            uploadHeaders () {
                let headers = {}
                const token = dataUtils.getData(Setting.key.token)
                headers['token'] = token;
                headers = secretUtils.createSign(headers)
                return headers
            },
            //上传前事件
            handleBeforeUpload (res) {
              var typeArr = this.typeArr.indexOf(res.type) !== -1
              var imgTypeArr = this.imgTypeArr.indexOf(res.type) !== -1
              if (this.contractSizeFlag ){
                if (!typeArr) {
                  this.$Message.warning({
                    content: '文件  ' + res.name + '  格式不正确, 请选择jpg或png或PDF.',
                    duration: 5
                  });
                  return false
              }
                if (imgTypeArr) {
                  // 控制文件上传大小
                  var Maxsize = res.size < this.maxSize
                  if (!Maxsize) {
                    this.$Message.warning({
                      content: '文件  ' + res.name + ' 体积过大, 最大不能超过1M.',
                      duration: 5
                    });
                    return false
                  }
                }
              }


                if (this.limit != null) {
                    if (this.fileList.length >= this.limit) {
                        appUtils.showError('超过最大上传数量，最大数量：' + this.limit)
                        return false;
                    }
                }
                return true;
            },
            //上传成功
            uploadSuccess (res, file, fileList) {
                if (res.state) {
                    if (this.multiple) {
                        this.fileList.push(res.data)
                        this.$emit('input', JSON.stringify(this.fileList))
                        this.$emit('on-change', res.data)
                    } else {
                        this.fileList = [res.data]
                        this.$emit('input', JSON.stringify(res.data))
                        this.$emit('on-change', res.data)

                    }
                } else {
                    appUtils.showError(res.msg)
                }
            },
            //移除
            removeImage (index) {
                this.fileList.splice(index, 1);
                if (this.fileList.length > 0) {
                    this.$emit('input', JSON.stringify(this.fileList))
                    this.$emit('on-change', JSON.stringify(this.fileList));
                } else {
                    this.$emit('input', '')
                    this.$emit('on-change', '');
                }

            },
            viewImage (item){
              this.imgShow = true;
              this.imgUrl = item;

             },
            downloadPdf (url) {
                location.href = Setting.file.path + url
            },
            viewPdf(url){
                this.pdfUrl = Setting.file.path + url;
                this.pdfShow = true;
            }
        },
        mounted () {
            // if (this.value != null && this.value != '') {
            //     let parse = JSON.parse(this.value);
            //     let img = dataUtils.getImg(parse.bucketName, parse.fileName);
            //     this.fileList = [img]
            // }
            if (this.value != null && this.value != '') {
                if (!this.image){
                    if (this.multiple){
                        let parse = JSON.parse(this.value);
                        this.fileList = parse
                    } else{
                        this.fileList = [this.value]
                    }

                } else{
                    let parse = JSON.parse(this.value);
                    let img = dataUtils.getImg(parse.bucketName, parse.fileName);
                    this.fileList = [img]
                }
            } else {
                this.fileList = []
            }
        }
    };
</script>
<style>
    .imgModel{
      position: absolute;
      top: 10000px;

    }
    .dosion-upload-list {
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        /*background: #009E42;*/
      background-color: #009E42;
        position: relative;
        box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
        margin-right: 4px;
    }

    .dosion-upload-list img {
        width: 100%;
        height: 100%;
    }

    .dosion-upload-list-cover {
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, .6);
    }

    .dosion-upload-list:hover .dosion-upload-list-cover {
        display: block;
    }

    .dosion-upload-list-cover i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
